var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowheadLeft01 = function SvgArrowheadLeft01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M12.971 0h8.554l-9.866 12.152-3.066 3.779.073.09 3.106 3.825L21.636 32h-8.554L4.389 21.29l-.074-.089-.038.046L0 15.978l4.277-5.27z"
  })));
};
export { SvgArrowheadLeft01 as ReactComponent };
export default __webpack_public_path__ + "assets/Arrowhead-Left-01.3e11a3f1baa438cd357ca6480dd8d8cb.svg";